import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const showSuccessToast = (message) => {
  // Dismiss any existing toasts before showing a new one
  toast.dismiss();

  toast.success(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined
  });
};

export const showWarningToast = (message) => {
  toast.dismiss();

  toast.warn(message, {
    position: "top-right",
    autoClose: 12000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined
  });
};

export const showErrorToast = (message) => {
  // Dismiss any existing toasts before showing a new one
  toast.dismiss();

  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined
  });
};
